module.exports = __webpack_public_path__ + "static/banner_ouvidoria_mobile-eab709fa06d1c354b798efe704325dc8.jpeg";